/**
 * Environment-aware logger.
 * - In development (NODE_ENV !== 'production'): forwards to console.{debug,error,warn}
 * - In production: no-op (silent), so we don't leak client-side context to end users
 *
 * Usage:
 *   import { log } from '@/lib/logger';
 *   log.debug('Payments: fetch failed', err);
 *   log.error('Auth: unexpected shape', payload);
 */
const isDev = process.env.NODE_ENV !== 'production';

const noop = () => {};

export const log = {
  debug: isDev ? console.debug.bind(console) : noop,
  error: isDev ? console.error.bind(console) : noop,
  warn: isDev ? console.warn.bind(console) : noop,
};

export default log;
